import styled, { css } from "styled-components";
import Link from "../Link";

export const EntryNameWrapper = styled.div`
  padding: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[2]};
`;

export const EntryFullName = styled.h2`
  margin-top: 0;
  margin-bottom: ${({ theme }) => `${theme.space[1]}`};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.white1};
  line-height: 24px;
`;

export const EntryName = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  padding-inline-end: ${({ theme }) => `${theme.space[1]}`};
  font-family: ${({ theme }) => theme.fonts.book};
  font-size: 17px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.white1};
  line-height: 20px;
`;

export const DataListItem = styled.li`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.space[2]} 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey};
  font-size: ${({ theme }) => theme.fontSizes[1]};
`;

export const DataListHeading = styled.h5`
  flex: 1 0 65%;
  padding: 0 ${({ theme }) => theme.space[2]};
`;

export const DataListValue = styled.div`
  flex: 1 0 35%;
  padding: 0 ${({ theme }) => theme.space[2]};
`;

const boldStyles = css`
  color: ${({ theme }) => theme.colors.white1};
  font-weight: bold;
`;

export const BoldText = styled.span`
  ${boldStyles}
`;

export const StyledLink = styled(Link)`
  ${boldStyles}
`;

export const StyledTdFixedWidth = styled.td`
  width: 33%;
`;

export const PanelWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.space[4]};
`;

export const FooterWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space[1]};
  padding-inline: ${({ theme }) => theme.space[2]};
`;

export const ButtonLayoutWrapper = styled.div`
  padding: ${({ theme }) => theme.space[1]};
`;
